// ============================================================================
// WIDGET SANDBOX — Theme Token Serialization
// Extracts a flat, postMessage-safe subset from Beoflow's MUI theme
// ============================================================================

import { beoflowColors, spacing, borderRadius, typography } from '@/theme/muiTheme'
import type { WidgetThemeTokens } from './types'

export function extractWidgetThemeTokens(mode: 'light' | 'dark' = 'dark'): WidgetThemeTokens {
  const isLight = mode === 'light'
  return {
    colors: {
      primary: beoflowColors.meanBlue,
      secondary: beoflowColors.peakOrange,
      background: isLight ? beoflowColors.beoWhite : beoflowColors.beoBlacker,
      surface: isLight ? '#FFFFFF' : beoflowColors.beoBlack,
      text: isLight ? beoflowColors.beoBlack : beoflowColors.beoWhite,
      textSecondary: isLight ? beoflowColors.graphGreyDark : beoflowColors.graphGreyLight,
      error: beoflowColors.redBase,
      warning: beoflowColors.yoloYellow,
      success: beoflowColors.biancchiTeal,
      accent: beoflowColors.pimpinPurple,
    },
    fonts: {
      body: typography.fontFamilySansSerif,
      mono: typography.fontFamilyMonospace,
    },
    spacing: {
      xs: spacing.xs,
      sm: spacing.sm,
      md: spacing.md,
      lg: spacing.lg,
      xl: spacing.xl,
    },
    borderRadius: {
      small: borderRadius.small,
      medium: borderRadius.medium,
      large: borderRadius.large,
      round: borderRadius.round,
    },
  }
}
